import { pushToDataLayer } from '@/utils/gtm'

interface userPlusMemberProps {
  userId: number
  memberId: number
}

interface userProps {
  userId: number
}

export const directEasyPauseEvent = ({ userId, memberId }: userPlusMemberProps): void => pushToDataLayer({
  event: 'member_quick_pause',
  event_action: 'direct_pause_activated',
  userId,
  memberId
})

export const inDirectEasyPauseEvent = ({ userId, memberId }: userPlusMemberProps): void => pushToDataLayer({
  event: 'member_quick_pause_indirect',
  event_action: 'indirect_pause_activated',
  userId,
  memberId
})

export const directEasyActivateEvent = ({ userId, memberId }: userPlusMemberProps): void => pushToDataLayer({
  event: 'member_activate_immediately',
  event_action: 'inactive_member_reactivated',
  userId,
  memberId
})

export const pleaseStayActivatedEvent = ({ userId, memberId }: userPlusMemberProps): void => pushToDataLayer({
  event: 'member_please_stay',
  event_action: 'please_stay_activated',
  userId,
  memberId
})

export const saveLoyaltyRewardsEvent = ({ userId, memberId }: userPlusMemberProps): void => pushToDataLayer({
  event: 'member_save_loyalty_credit',
  event_action: 'member_saved_credits',
  userId,
  memberId
})

export const inviteAFriendEvent = ({ userId }: userProps): void => pushToDataLayer({
  event: 'user_invite_friends',
  event_action: 'invite_friends_clicked',
  userId
})

export const activateFreeSocksEvent = ({ userId }: userProps): void => pushToDataLayer({
  event: 'user_free_socks',
  event_action: 'free_socks_activated',
  userId
})

export const goToWebshopEvent = ({ userId }: userProps): void => pushToDataLayer({
  event: 'loyalty_go_to_webshop',
  event_action: 'account_enter_webshop',
  userId
})

export const copyLoyaltyInviteLinkEvent = ({ userId }: userProps): void => pushToDataLayer({
  event: 'loyalty_invite_link',
  event_action: 'referral_code_copied',
  userId
})

export const copyWomenLoyaltyInviteLinkEvent = ({ userId }: userProps): void => pushToDataLayer({
  event: 'women_loyalty_invite_link',
  event_action: 'women_referral_code_copied',
  userId
})

export const shareLoyaltyLinkThroughWhatsappEvent = ({ userId }: userProps): void => pushToDataLayer({
  event: 'loyalty_invite_whatsapp',
  event_action: 'referral_code_whatsapp',
  userId
})

type TrackCancelFlowProps = userPlusMemberProps & {
  flowStepCount: number
  flowStep: string
  flowAction: string
  flowDetail?: string | number
}

export const trackCancelFlow = ({ userId, memberId, flowStepCount, flowStep, flowAction, flowDetail }: TrackCancelFlowProps):void => pushToDataLayer({
  event: 'cancelFlow',
  userId,
  memberId,
  flowStepCount,
  flowStep,
  flowAction,
  ...(flowDetail ? { flowDetail } : {})
})

export const identifyUserEvent = ({ otaUserId }: { otaUserId: string }): void => pushToDataLayer({
  event: 'identify_user',
  otaUserId
})

export const downloadWithdrawalForm = (): void => pushToDataLayer({
  event: 'download_withdrawal_form'
})
